// extracted by mini-css-extract-plugin
module.exports = {"social_btn":"SocialButtons_social_btn__s9zxn","google_btn":"SocialButtons_google_btn__Zphew","facebook_btn":"SocialButtons_facebook_btn__Qt_A7"};